import { ImageWithFallback } from '~/hooks/common/ui/useImageWithFallback';
import { ImageType } from './hooks/useGetImages';
import { ImageWrapper, Vehicle } from './WhyBuy.styles';

type OwnProps = {
  image?: ImageWithFallback<ImageType>;
};

export default function WhyBuyVehicleImage({ image }: OwnProps) {
  return image ? (
    <ImageWrapper>
      <Vehicle
        alt={`${image.imageType} image`}
        data-testid="why-buy-vehicle"
        src={image.url}
      />
    </ImageWrapper>
  ) : null;
}
